import type { HTMLAttributes } from "react";

import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

/**
 * Root layout classes per variant. Each variant defines the structure
 * (avatar + lines, lines + image, or plain text lines); widths are left to
 * the consumer via the wrapping element / `className`.
 */
export const SKELETON_VARIANT_CLASS_MAP = {
  default: "items-center gap-4",
  card: "flex-col gap-6",
  text: "flex-col gap-2",
} as const;

export const INPUT_FIELD_SKELETON_CLASS_NAME =
  "h-10 w-full rounded-sys-sm";

export const INPUT_LABEL_SKELETON_CLASS_NAME =
  "h-4 w-24 rounded-sys-sm";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TSkeletonVariant = keyof typeof SKELETON_VARIANT_CLASS_MAP;

export type TSkeletonProps = {
  variant?: TSkeletonVariant;
} & HTMLAttributes<HTMLDivElement>;

export type TInputSkeletonProps = HTMLAttributes<HTMLDivElement>;

type TSkeletonDefaultProps = DefinedDefaults<TSkeletonProps, "variant">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SKELETON_DEFAULTS = {
  variant: "default",
} satisfies TSkeletonDefaultProps;
